var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 46,
    viewBox: "0 0 83 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7673 12.1819L39.1452 34.0001H34.5322L38.1544 12.1819H42.7673Z",
    fill: "url(#paint0_linear_1514_26607)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2804 34.0001L45.9026 12.1819H54.5105C56.1583 12.1819 57.5113 12.4979 58.5695 13.13C59.6348 13.755 60.3806 14.6251 60.8067 15.7401C61.2399 16.8481 61.3394 18.1265 61.105 19.5754C60.8635 21.0313 60.338 22.3133 59.5283 23.4212C58.7257 24.5221 57.6817 25.3815 56.3962 25.9994C55.1107 26.6173 53.6263 26.9262 51.9431 26.9262H46.4566L47.0638 23.2295H51.8046C52.6995 23.2295 53.463 23.0768 54.0951 22.7714C54.7343 22.4589 55.2421 22.0292 55.6185 21.4823C55.9949 20.9283 56.2399 20.2927 56.3536 19.5754C56.4743 18.8438 56.4353 18.2082 56.2364 17.6684C56.0375 17.1286 55.6718 16.7096 55.1391 16.4113C54.6135 16.1059 53.9068 15.9532 53.0191 15.9532H49.9083L46.8934 34.0001H42.2804Z",
    fill: "url(#paint1_linear_1514_26607)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9157 12.1819L79.2935 34.0001H75.3092L68.1181 20.2678H67.9477L65.6572 34.0001H61.0443L64.6664 12.1819H68.7147L75.8738 25.9035H76.0549L78.3241 12.1819H82.9157Z",
    fill: "url(#paint2_linear_1514_26607)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9681 1.60775C19.2161 2.08873 22.3996 2.92518 25.4576 4.10107L28.5861 5.30405C29.0342 5.47636 29.3774 5.83803 29.517 6.28527C29.6567 6.7325 29.5775 7.21586 29.3021 7.59662L22.3974 19.3434L28.2379 21.2051C28.7353 21.3358 29.1366 21.6944 29.3117 22.1648C29.4868 22.6351 29.4134 23.1574 29.1153 23.5624L28.4589 24.4541C23.9051 30.6409 16.6685 36.5331 10.3544 41.0364L9.30276 41.7864C8.76753 42.1681 8.03987 42.1786 7.48821 41.8127C6.93656 41.4467 6.68134 40.7841 6.85178 40.1603L11.3002 25.1017L6.85051 22.995C6.06495 22.7886 5.56815 22.0356 5.70572 21.2598L6.19692 18.4897C7.02802 13.8028 8.286 9.1991 9.95611 4.73264L10.9432 2.09285C11.1967 1.41491 11.9081 1.00651 12.6454 1.11569L15.9681 1.60775Z",
    fill: "url(#paint3_linear_1514_26607)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3977 19.3433L28.2382 21.205C28.7357 21.3357 29.1369 21.6943 29.312 22.1647C29.4871 22.6351 29.4137 23.1573 29.1157 23.5623L28.4593 24.454C23.9054 30.6408 16.6688 36.533 10.3547 41.0363L9.30308 41.7863C8.76785 42.168 8.04019 42.1786 7.48854 41.8126C6.93688 41.4466 6.68166 40.784 6.8521 40.1603L11.3006 25.1016C12.0932 22.7768 13.5026 18.4725 13.6786 18.1272C13.8547 17.782 14.3621 17.3605 14.5589 17.264C14.9991 17.0482 15.6593 17.1921 15.8794 17.2641L22.3977 19.3433Z",
    fill: "url(#paint4_linear_1514_26607)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1514_26607",
    x1: 63.43,
    y1: 12.1819,
    x2: 47.6828,
    y2: 31.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479094,
    stopColor: "#4D4E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2B32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1514_26607",
    x1: 63.43,
    y1: 12.1819,
    x2: 47.6828,
    y2: 31.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479094,
    stopColor: "#4D4E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2B32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1514_26607",
    x1: 63.43,
    y1: 12.1819,
    x2: 47.6828,
    y2: 31.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479094,
    stopColor: "#4D4E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2B32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1514_26607",
    x1: 27.1318,
    y1: 7.89087,
    x2: -1.29253,
    y2: 20.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF49A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1514_26607",
    x1: 25.0694,
    y1: 21.9522,
    x2: 6.38237,
    y2: 31.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89C08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.f19df0a3162251c6161e932bf37208f6.svg";
export { ForwardRef as ReactComponent };